export let messages = {
  USER_ID: "userid",
  TOKEN: "token",
  USER_ROLE: "userRole",
  PROJECT_ID: "projectId",
  BATCH_ID: "batchId",
  PROJECT_NAME: "projectName",
  USER_NAME: "userName",
  BATCH_NAME: "batchName",
  AUTH_CREDS: "Provide your Credentials",
  USER_NAME_AUTH: "User Name",
  PASS: "Password",
  SUCCESS: "success",
  ERROR: "error",
  CLEAR: "Clear",
  LAST_LOGIN: "last_login",
  AUTH_P:
    "Electronic signatures are considered to be the legally binding equivalent to full handwritten signature by the FDA according to 21 CFR part 11",
  APPLICATION_VERSION: "Application Version",
  VERSION_NUMBER: "2.1",
  APP_VERSION : "CAM 2.1"
};
